import React, { useEffect } from 'react';

function AppointmentDetail() {
        


        const fetchDoctors = async () => {
                // setLoading(true);
                try {
                //   const token = localStorage.getItem('access_token'); 
                  
                  const response = await fetch('https://hms-g2gbera0bddsdugv.canadacentral-01.azurewebsites.net/appointment/patientdetails', {
                      
                //     headers: {
                // //       'Authorization': `Bearer ${token}`
                //     }
                  });
                  
                  if (!response.ok) {
                    throw new Error('Failed to fetch doctors');
                  }
                  
                  const data = await response.json();
                  console.log(data);
            
                //   setDoctors(data.doctors || []);
                  // toast.success('Doctors loaded successfully');
                } catch (error) {
                //   setMessage('Error loading doctors. Please try again later.');
                  // toast.error('Error loading doctors. Please try again later.');
                  console.error('Error fetching doctors:', error);
                } finally {
                //   setLoading(false);
                }
              };

              useEffect(() => {
                
                fetchDoctors()
              
        }, []);
        






  // Static data to display
  const appointmentData = [
    {
      activity_name: "General Checkup",
      docname: "Dr. Smith",
      activity_amount: "$120"
    },
    {
      activity_name: "Blood Test",
      docname: "Dr. Johnson",
      activity_amount: "$85"
    },
    {
      activity_name: "X-Ray Scan",
      docname: "Dr. Williams",
      activity_amount: "$250"
    },
    {
      activity_name: "Dental Cleaning",
      docname: "Dr. Davis",
      activity_amount: "$150"
    }
  ];

  return (
    <div className="p-4 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold mb-6">Appointment Details</h2>
      
      <div className="grid gap-4 grid-cols-1 md:grid-cols-2">
        {appointmentData.map((appointment, index) => (
          <div key={index} className="border rounded-lg p-4 mb-4 shadow-sm hover:shadow-md transition-shadow">
            <h3 className="font-bold text-lg mb-3">{appointment.activity_name}</h3>
            <p className="mb-2">
              <span className="font-medium">Doctor:</span> {appointment.docname}
            </p>
            <p className="mb-2">
              <span className="font-medium">Amount:</span> <span className="text-green-600 font-semibold">{appointment.activity_amount}</span>
            </p>
          </div>
        ))}
      </div>
      
      {appointmentData.length === 0 && (
        <div className="text-center p-8 border rounded-lg">
          <p className="text-lg">No appointments found.</p>
        </div>
      )}
    </div>
  );
}

export default AppointmentDetail;